import http from "@/http-common";
import httpFile from "@/http-multipart";

const BASE_URL = "/attendance-kids-v4";

class AttendanceV3Service {

    async getAllAttendanceClass({idClass, idGrade, date, limit, offset, status, marked}) {
        const params = {
            idClass: idClass,
            idGrade: idGrade,
            date: date,
            size: limit,
            page: offset,
            status: status,
            marked: marked
        }

        return await http.get(BASE_URL + '/class', {params});
    }

    async getAllAttendanceGroup({idGroup, date, limit, offset, status, marked}) {
        const params = {
            idGroup: idGroup,
            date: date,
            size: limit,
            page: offset,
            status: status,
            marked: marked
        }

        return await http.get(BASE_URL + '/group', {params});
    }

    saveAttendanceFile({attendances}) {
        return httpFile.post(BASE_URL + '/bulk-save', attendances);
    }

    getDetailByIdStudent({idStudent, date, type, idGroup}) {
        const params = {
            idStudent: idStudent,
            date: date,
            type: type,
            idGroup: idGroup
        }
        return http.get(BASE_URL + '/student/detail', {params})
    }

    getEditHistoryAttendance({idAttendance}) {
        const params = {
            idAttendance: idAttendance,
        }

        return http.get(BASE_URL + '/student-history', {params})
    }

    getAttendanceDayExportExcelClass({classId, date}) {
        const params = {
            idClass: classId,
            date: date,
        }
        return http.get(BASE_URL + '/report/daily/class', {params})
    }

    getAttendanceDayExportExcelGroup({groupId, date}) {
        const params = {
            idGroup: groupId,
            date: date,
        }
        return http.get(BASE_URL + '/report/daily/group', {params})
    }

    getAttendanceMonthExportExcelClass({classId, startDate, endDate, status}) {
        const body = {
            idClass: classId,
            fromDate: startDate,
            toDate: endDate,
            status: status,
        }
        return http.post(BASE_URL + '/report/monthly/class', body)
    }

    getAttendanceMonthExportExcelGroup({groupId, startDate, endDate, status}) {
        const body = {
            idGroup: groupId,
            fromDate: startDate,
            toDate: endDate,
            status: status,
        }
        return http.post(BASE_URL + '/report/monthly/group', body)
    }

    getAttendanceSummaryExcelClass({classId, startDate, endDate, status}) {
        const data = {
            idClass: classId,
            fromDate: startDate,
            toDate: endDate,
            status: status,
        }

        return http.post(BASE_URL + '/report/student-summary/class', data)
    }

    getAttendanceSummaryExcelGroup({groupId, startDate, endDate, status}) {
        const data = {
            idGroup: groupId,
            fromDate: startDate,
            toDate: endDate,
            status: status,
        }

        return http.post(BASE_URL + '/report/student-summary/group', data)
    }

    getAttendanceMonthlyDetailExcelClass({classId, startDate, endDate, status}) {
        const data = {
            idClass: classId,
            fromDate: startDate,
            toDate: endDate,
            status: status,
        }

        return http.post(BASE_URL + '/report/monthly-detail/class', data)
    }

    getAttendanceMonthlyDetailExcelGroup({groupId, startDate, endDate, status}) {
        const data = {
            idGroup: groupId,
            fromDate: startDate,
            toDate: endDate,
            status: status,
        }

        return http.post(BASE_URL + '/report/monthly-detail/group', data)
    }

    getListKidsGroup() {
        return http.get(BASE_URL + '/listNameKidsGroup')
    }
}

export default new AttendanceV3Service();